import { findObjectInArray, isObject, parseJson, handleFilter } from '@/utils'

const state = () => ({
  doorCanvasType: {
    image: null,
    price: 0
  },
  doorPatternType: {
    image: null,
    price: 0
  },
  doorExteriorPatternType: {
    image: null,
    price: 0
  },
  doorFrame: {
    image: null,
    price: 0
  },
  doorColor: {
    image: null,
    price: 0
  },
  doorExteriorColor: {
    image: null,
    price: 0
  },
  doorCasingThickness: {
    price: 0
  },
  doorCanvasThickness: {
    price: 0
  },
  doorSize: {
    price: 0
  },
  doorHingeFeature: {
    price: 0
  },
  doorLockFeature: {
    image: null,
    price: 0
  },
  doorHandleFeature: {
    image: null,
    price: 0
  },
  doorEyeHoleFeature: {
    image: null,
    price: 0
  },
  doorExtraLockFeature: {
    price: 0
  },
  doorDeliveryFeature: {
    value: 'no',
    price: 0
  },
  doorInstallationFeature: {
    value: 'no',
    price: 0
  },
  doorOpeningFeature: {
    value: 'left'
  },
  doorQty: 1,
  messageCalc: '',
  exteriorFrame: {},
  categoryFilters: [{}]
})

const getters = {
  doorTotalPricing: (state) =>
    state.doorQty *
      (state.doorCanvasType.price +
        state.doorPatternType.price +
        state.doorExteriorPatternType.price +
        state.doorFrame.price +
        state.doorColor.price +
        state.doorExteriorColor.price +
        state.doorCasingThickness.price +
        state.doorCanvasThickness.price +
        state.doorSize.price +
        state.doorHingeFeature.price +
        state.doorLockFeature.price +
        state.doorHandleFeature.price +
        state.doorEyeHoleFeature.price +
        state.doorExtraLockFeature.price) +
    state.doorDeliveryFeature.price +
    state.doorInstallationFeature.price,
  doorCanvasType: (state) => state.doorCanvasType,
  doorPatternType: (state) => state.doorPatternType,
  doorExteriorPatternType: (state) => state.doorExteriorPatternType,
  doorFrame: (state) => state.doorFrame,
  doorColor: (state) => state.doorColor,
  doorExteriorColor: (state) => state.doorExteriorColor,
  doorCasingThickness: (state) => state.doorCasingThickness,
  doorCanvasThickness: (state) => state.doorCanvasThickness,
  doorSize: (state) => state.doorSize,
  doorHingeFeature: (state) => state.doorHingeFeature,
  doorLockFeature: (state) => state.doorLockFeature,
  doorHandleFeature: (state) => state.doorHandleFeature,
  doorEyeHoleFeature: (state) => state.doorEyeHoleFeature,
  doorExtraLockFeature: (state) => state.doorExtraLockFeature,
  doorDeliveryFeature: (state) => state.doorDeliveryFeature,
  doorInstallationFeature: (state) => state.doorInstallationFeature,
  doorOpeningFeature: (state) => state.doorOpeningFeature,
  doorQty: (state) => state.doorQty,
  messageCalc: (state) => state.messageCalc,
  exteriorFrame: (state) => state.exteriorFrame
}

const mutations = {
  RESET_DOOR_TOTAL_PRICING(state) {
    state.doorCanvasType.image = null
    state.doorCanvasType.price = 0

    state.doorPatternType.image = null
    state.doorPatternType.price = 0

    state.doorExteriorPatternType.image = null
    state.doorExteriorPatternType.price = 0

    state.doorFrame.image = null
    state.doorFrame.price = 0

    state.doorColor.image = null
    state.doorColor.price = 0

    state.doorExteriorColor.image = null
    state.doorExteriorColor.price = 0

    state.doorCasingThickness.price = 0
    state.doorCanvasThickness.price = 0
    state.doorSize.price = 0
    state.doorHingeFeature.price = 0

    state.doorLockFeature.image = null
    state.doorLockFeature.price = 0

    state.doorHandleFeature.image = null
    state.doorHandleFeature.price = 0

    state.doorEyeHoleFeature.image = null
    state.doorEyeHoleFeature.price = 0

    state.doorExtraLockFeature.price = 0

    state.doorDeliveryFeature.value = 'no'
    state.doorDeliveryFeature.price = 0

    state.doorInstallationFeature.value = 'no'
    state.doorInstallationFeature.price = 0
    state.doorOpeningFeature.value = 'left'
    state.doorQty = 1
  },
  RESET_DOOR_COLOR(state) {
    state.doorColor = {
      image: null,
      price: 0
    }
  },
  SET_DOOR_CANVAS_TYPE(state, payload) {
    state.doorCanvasType = Object.assign(state.doorCanvasType, payload)
  },
  SET_DOOR_PATTERN_TYPE(state, payload) {
    state.doorPatternType = Object.assign(state.doorPatternType, payload)
  },
  RESET_EXTERIOR_DOOR_COLOR(state) {
    state.doorExteriorColor = {
      image: null,
      price: 0
    }
    state.exteriorFrame = {}
  },
  SET_DOOR_EXTERIOR_PATTERN_TYPE(state, payload) {
    state.doorExteriorPatternType = Object.assign(
      state.doorExteriorPatternType,
      payload
    )
  },
  SET_DOOR_FRAME(state, payload) {
    state.doorFrame = Object.assign(state.doorFrame, payload)
  },
  SET_DOOR_COLOR(state, payload) {
    state.doorColor = Object.assign(state.doorColor, payload)
  },
  SET_DOOR_EXTERIOR_COLOR(state, payload) {
    state.doorExteriorColor = Object.assign(state.doorExteriorColor, payload)
  },
  SET_DOOR_CASING_THICKNESS(state, payload) {
    state.doorCasingThickness = Object.assign(
      state.doorCasingThickness,
      payload
    )
  },
  SET_DOOR_CANVAS_THICKNESS(state, payload) {
    state.doorCanvasThickness = Object.assign(
      state.doorCanvasThickness,
      payload
    )
  },
  SET_DOOR_SIZE(state, payload) {
    state.doorSize = Object.assign(state.doorSize, payload)
  },
  SET_DOOR_HINGE(state, payload) {
    state.doorHingeFeature = Object.assign(state.doorHingeFeature, payload)
  },
  SET_DOOR_LOCK(state, payload) {
    state.doorLockFeature = Object.assign(state.doorLockFeature, payload)
  },
  SET_DOOR_HANDLE(state, payload) {
    state.doorHandleFeature = Object.assign(state.doorHandleFeature, payload)
  },
  SET_DOOR_EYE_HOLE(state, payload) {
    state.doorEyeHoleFeature = Object.assign(state.doorEyeHoleFeature, payload)
  },
  SET_EXTRA_DOOR_LOCK(state, payload) {
    state.doorExtraLockFeature = Object.assign(
      state.doorExtraLockFeature,
      payload
    )
  },
  SET_DOOR_DELIVERY(state, payload) {
    if (payload === 'yes') {
      state.doorDeliveryFeature.value = 'yes'
      state.doorDeliveryFeature.price = 15000
    } else {
      state.doorDeliveryFeature.value = 'no'
      state.doorDeliveryFeature.price = 0
    }
  },
  SET_DOOR_INTALLATION(state, payload) {
    if (payload === 'yes') {
      state.doorInstallationFeature.value = 'yes'
      state.doorInstallationFeature.price = 15000
    } else {
      state.doorInstallationFeature.value = 'no'
      state.doorInstallationFeature.price = 0
    }
  },
  SET_DOOR_OPENING(state, payload) {
    state.doorOpeningFeature.value = payload
  },
  SET_DOOR_QTY(state, payload) {
    state.doorQty = parseInt(payload)
  },
  SET_MESSAGE_CALC(state, payload) {
    state.messageCalc = payload
  },
  SET_EXTERIOR_FRAME(state) {
    if (
      isObject(state.doorExteriorColor) &&
      state.doorExteriorColor.json_data
    ) {
      const frames = findObjectInArray(
        parseJson(state.doorExteriorColor.json_data),
        ['id'],
        3
      ).data
      if (isObject(state.doorFrame) && state.doorFrame.id) {
        state.exteriorFrame = findObjectInArray(
          frames,
          'id',
          state.doorFrame.id
        )
      } else {
        state.exteriorFrame = frames[0]
      }
    } else {
      state.exteriorFrame = {}
    }
  }
}

const actions = {
  setDoorCanvasType({ commit }, payload) {
    commit('RESET_DOOR_TOTAL_PRICING')
    commit('SET_DOOR_CANVAS_TYPE', payload)
  },
  setDoorPatternType({ commit, dispatch }, payload) {
    dispatch('resetInnerColor', payload)
    commit('SET_DOOR_PATTERN_TYPE', payload)
  },
  setDoorExteriorPatternType({ commit, dispatch }, payload) {
    dispatch('resetExteriorColor', payload)
    commit('SET_DOOR_EXTERIOR_PATTERN_TYPE', payload)
  },
  setDoorFrame({ commit }, payload) {
    commit('SET_DOOR_FRAME', payload)
    commit('SET_EXTERIOR_FRAME')
  },
  setDoorColor({ commit }, payload) {
    commit('SET_DOOR_COLOR', payload)
  },
  setDoorExteriorColor({ commit }, payload) {
    commit('SET_DOOR_EXTERIOR_COLOR', payload)
    commit('SET_EXTERIOR_FRAME')
  },
  setCasingDoorThickness({ commit }, payload) {
    commit('SET_DOOR_CASING_THICKNESS', payload)
  },
  setCanvasDoorThickness({ commit }, payload) {
    commit('SET_DOOR_CANVAS_THICKNESS', payload)
  },
  setDoorSize({ commit }, payload) {
    commit('SET_DOOR_SIZE', payload)
  },
  setDoorHinge({ commit }, payload) {
    commit('SET_DOOR_HINGE', payload)
  },
  setDoorLock({ commit }, payload) {
    commit('SET_DOOR_LOCK', payload)
  },
  setDoorHandle({ commit }, payload) {
    commit('SET_DOOR_HANDLE', payload)
  },
  setDoorEyeHole({ commit }, payload) {
    commit('SET_DOOR_EYE_HOLE', payload)
  },
  setExtraDoorLock({ commit }, payload) {
    commit('SET_EXTRA_DOOR_LOCK', payload)
  },
  setDoorDelivery({ commit }, payload) {
    commit('SET_DOOR_DELIVERY', payload)
  },
  setDoorInstallation({ commit }, payload) {
    commit('SET_DOOR_INTALLATION', payload)
  },
  setDoorOpening({ commit }, payload) {
    commit('SET_DOOR_OPENING', payload)
  },
  setDoorQty({ commit }, { qty }) {
    commit('SET_DOOR_QTY', qty)
  },
  setMessageCalc({ commit }, payload) {
    commit('SET_MESSAGE_CALC', payload)
  },
  clearTotalPricing({ commit }) {
    commit('RESET_DOOR_TOTAL_PRICING')
  },
  resetInnerColor({ commit, rootState }, payload) {
    const details = rootState.calculator.calcDetails
    const colors = handleFilter(details[4], payload, 2)
    if (colors.length === 0) {
      commit('RESET_DOOR_COLOR')
    } else {
      commit('SET_DOOR_COLOR', colors[0])
    }
  },
  resetExteriorColor({ commit, rootState }, payload) {
    const details = rootState.calculator.calcDetails
    const colors = handleFilter(details[14], payload, 13)
    if (colors.length === 0) {
      commit('RESET_EXTERIOR_DOOR_COLOR')
    } else {
      commit('SET_DOOR_EXTERIOR_COLOR', colors[0])
      commit('SET_EXTERIOR_FRAME')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
